import Swal, { SweetAlertIcon } from "sweetalert2";
export class SwalService{
    constructor(){}
    showAlert(title:string,text:string,icon:SweetAlertIcon,isDisplayCancelButton:boolean,confirmButtonText:string){
        return Swal.fire({
            title: title,
            text: text,
            icon: icon,
            showCancelButton: isDisplayCancelButton,
            confirmButtonText: confirmButtonText
          });
 
    }
 
}